var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_281",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C4 3.10457 3.10457 4 2 4C0.89543 4 0 3.10457 0 2C0 0.89543 0.89543 0 2 0C3.10457 0 4 0.89543 4 2ZM4 8C4 9.10457 3.10457 10 2 10C0.89543 10 0 9.10457 0 8C0 6.89543 0.89543 6 2 6C3.10457 6 4 6.89543 4 8ZM2 16C3.10457 16 4 15.1046 4 14C4 12.8954 3.10457 12 2 12C0.89543 12 0 12.8954 0 14C0 15.1046 0.89543 16 2 16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C4.20914 6 6 4.20914 6 2H2V6ZM-2 2C-2 4.20914 -0.209139 6 2 6V2H-2ZM2 -2C-0.209139 -2 -2 -0.209139 -2 2H2V-2ZM6 2C6 -0.209139 4.20914 -2 2 -2V2H6ZM2 12C4.20914 12 6 10.2091 6 8H2V12ZM-2 8C-2 10.2091 -0.209139 12 2 12V8H-2ZM2 4C-0.209139 4 -2 5.79086 -2 8H2V4ZM6 8C6 5.79086 4.20914 4 2 4V8H6ZM2 14V18C4.20914 18 6 16.2091 6 14H2ZM2 14H6C6 11.7909 4.20914 10 2 10V14ZM2 14V10C-0.209139 10 -2 11.7909 -2 14H2ZM2 14H-2C-2 16.2091 -0.209139 18 2 18V14Z",
    fill: "#3E4056",
    mask: "url(#path-1-inside-1_0_281)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.a8791b78ed272de36e273a1ca0a01945.svg";
export { ForwardRef as ReactComponent };